<template>
  <section>
    <h3>Extra Benefits</h3>
    <el-form
      ref="extraBenefitsForm"
      :model="formData"
      :disabled="disabled"
      :rules="rules">
      <div class="box extra_box">
        <v-checkbox-extra
          v-model="formData.extra_benefits"
          :list="extraData"
          :block="true"
          @change="handleExtra"
        >
          <template #default="{ item }">
            <div class="flex">
              <div class="extra-name">{{ item['name'] }}</div>
            </div>
          </template>
          <template v-slot:extra="{extra}">
            <template v-if="formData.extra_benefits.includes(extra.id)">
              <div
                v-for="(itemCover,index) in extra.content.coverage"
                :key="'cover'+index"
                class="form-item margin-bottom">
                <span>{{itemCover.name}}</span>
                <v-input
                  v-model="itemCover.money"
                  keyFloatNumber
                  prepend="$"
                />
              </div>
              <div class=" form-item">
                <span>Remarks</span>
                <v-input
                  v-model="extra.content.remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </template>
          </template>
        </v-checkbox-extra>
      </div>
    </el-form>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {getReferralExtra} from '@api/refer'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'

export default {
  name: 'extraBenefitsForm',
  mixins: [MixinFormat, MixinRules],
  props: {
    classId: {
      type: [Number, String],//14 motor 21 domestic 24 decoration 26 home &fire
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      extraData: [],
      formData: {
        extra_benefits:[]
      },
      extra_content :{},
      isFirst:false,
      extraOriginData: [], //从接口读回来的extra
    }
  },
  computed: {
    ...mapState('coupon', ['couponCode', 'selectCode']),
  },
  watch: {
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
          // let {trm_of_cvr} = this.form||{}
          // let params={
          //   class_id:this.classId,
          //   trm_of_cvr:trm_of_cvr
          // }
          // this.network().getReferralExtra(params)
          this.$nextTick(()=>{
            if( this.extra_content)
              this.hanlderInitExtraContent()
          })
        }
      }
    },
    classId: {
      immediate: true,
      handler(val) {
        if (val) {
          // this.network().getReferralExtra(val)
        }
      }
    },
    'form.extra_benefits': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && JSON.stringify(val) != JSON.stringify(old)) {
          this.formData.extra_benefits = val||[]
        }
      }
    },
    'form.trm_of_cvr': {
      immediate: true,
      deep: true,
      handler(val, old) {
        let {type} = this.form||{}
        if(val && val != old) {
          let params={
            class_id:this.classId,
            trm_of_cvr:val,
            is_renew_discount:type==20?1:0
          }
          this.$nextTick(()=>{
            this.network().getReferralExtra(params)
          })
        }
      }
    },
    'formData.extra_benefits':{
      immediate: true,
      deep: true,
      handler(val, old){
        this.$nextTick(()=>{
          if(JSON.stringify(val) != JSON.stringify(old)){
            this.handleExtra()
          }
        })
      }
    }
  },
  methods: {
    handleExtra(){
      let arr = []
      let extra_benefit_list = this.formData.extra_benefits
      // 获取选中的extra benefit初始值
      this.extraOriginData.map(item => {
        if(extra_benefit_list.includes(item.id)){
          arr.push(item)
        }
      })
      this.$emit('changeExtra', this.formData,this.index, arr)
    },
    handlerExtraContent(){
      let extra ={}
      this.extraData.forEach(item=>{
        let key = item.key
        extra[key] = item
      })
      this.$emit('changeExtraContent',{extra_benefits_content:extra},this.index)
    },
    hanlderInitExtraContent(){
      let {extra_benefits_content={},extra_benefits} = this.form||{}
      if(!extra_benefits_content) extra_benefits_content = {}
      Object.keys(this.extra_content).some(item=>{
        if(item in extra_benefits_content)
          this.extra_content[item] = extra_benefits_content[item]||{}
      })
      this.extraData = Object.entries(this.extra_content).map(item=>{
        item[1].id = Number(item[1].id)
        return item[1]
      })
      let arr = []
      let extra_benefit_list = extra_benefits
      // 获取选中的extra benefit初始值
      this.extraOriginData.map(item => {
        if(extra_benefit_list.includes(item.id)){
          arr.push(item)
        }
      })
      this.$emit('changeExtra', this.formData.extra_benefits,this.index, arr)

    },
    submitForm(formName) {
      let params = {
        extra_benefits_content:this.extraData,
        ...this.formData
      }
      this.$refs['extraBenefitsForm'].validate((valid, rules) => {
        if (valid)
          this.$emit('submitExtraBenefit', formName, params, this.index)
      })
    },
    network() {
      return {
        getReferralExtra: async (params) => {
          const {data} = await getReferralExtra(params)
          let extra ={}
          data.forEach(item=>{
            let key = item.key
            extra[key] = item||{}
          })
          this.extra_content =extra
          this.extraOriginData = data
          this.hanlderInitExtraContent()

          // 接口返回的id
          let originId = []
          data.forEach(item => {
            originId.push(item.id)
          })

          // 去除不存在的id
          let res = this.formData.extra_benefits.filter(item => {
            return originId.includes(item)
          })
          this.formData.extra_benefits = JSON.parse(JSON.stringify(res))
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-checkbox-group {
  .el-checkbox{
    padding: 20px  20px 0  20px;
    background: #FFFFFF;
    border: 1px solid #D1D5DA;
    box-sizing: border-box;
    border-radius: 6px;
    width: 50%;
    margin-bottom: 20px;
  }
}
.extra-name{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #24292E;
  margin-bottom: 20px;
}
.margin-bottom{
  padding-bottom: 20px;
}

.table {
  border: 1px solid #E1E4E8;
  border-radius: 8px;
  background-color: #FFFFFF;
  .tr {
    height: 64px;
    padding: 0 16px;
    color: #586069;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    align-items: center;
    justify-content: space-between;

    &:last-child {
      border-bottom: 0;
    }

    > span {
      flex: 2;
    }

    > div {
      flex: 2
    }
  }
  .tr:nth-child(2n) {
    background: none;
  }
  .style-2 {
    background-color: #F6F8FA !important;
    .span-right {
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 16px;
    }
    .min{
      text-align: center;
      color: #000;
    }
    .total{
      text-align: right;
      color: #000;
    }
  }
  .right {
    text-align: right;
    margin-left: 16px;
  }
  .right-width {
    margin-left: 20px;
    width: 69px;
  }
  .flex-algin {
    align-items: center;
    justify-content: flex-end;
  }
}
/deep/ .el-input-group__append {
  padding: 0 5px;
}
</style>
